import IMGPlanIds from '../../../helper-functions/companies/img-planids';
import { isInPlanList } from '../../../helper-functions/helper-functions';

const imgPlanIds = new IMGPlanIds();

const oldPlanIds = [
    4,
    21,
    319,
    320,
    imgPlanIds.Patriot_America_Plus
];

const newPlanIds = [
    imgPlanIds.Patriot_America_Lite,
    imgPlanIds.Patriot_International_Lite,
    imgPlanIds.Patriot_America_Platinum,
    imgPlanIds.Patriot_International_Platinum,
    imgPlanIds.Visitors_Protect
];

const visitorsCareIds = [
    imgPlanIds.Visitors_Care_Lite,
    imgPlanIds.Visitors_Care_Plus,
    imgPlanIds.Visitors_Care_Platinum
];

const allSHAPlans = [
    imgPlanIds.Student_Health_Advantage_Standard,
    imgPlanIds.Student_Health_Advantage_Platinum
];

const PEPSHA = [
    imgPlanIds.Patriot_Exchange_Program,
    ...allSHAPlans
];

const IMGConfig = {
    planId: ibJS.planId || (ibJS.application && ibJS.application.planId) || (ibJS.app && ibJS.app.planId),
    patriotTMPlans: [...oldPlanIds, ...newPlanIds],
    isSHA: function () {
        return isInPlanList(allSHAPlans, this.planId);
    },
    isPatriotTMPlans: function () {
        return isInPlanList(this.patriotTMPlans, this.planId);
    },
    isVisitorsCare: function () {
        return isInPlanList(visitorsCareIds, this.planId);
    },
    isPEPSHA: function () {
        return isInPlanList(PEPSHA, this.planId);
    }
};

export { IMGPlanIds, imgPlanIds, IMGConfig };
